import { getAnalyticsInstance } from '@/lib/firebase'
import { updateTikTokConsent } from '@/lib/tiktokPixel'

export const applyTrackingConsent = (hasConsent: boolean): void => {
  updateTikTokConsent(hasConsent)

  if (hasConsent) {
    void getAnalyticsInstance()
  }
}

export const getStoredAnalyticsConsent = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem('analytics-consent') === 'true'
}
